/**
 * This value was copied from `react-beautiful-dnd`
 */
export var zIndex = {
  dragging: 5000
};

/**
 * How far the drag preview is offset on the cross axis.
 *
 * Using a fixed value instead of a percentage, due to issues with the
 * offset growing too large.
 */
export var keyboardPreviewCrossAxisOffset = 24;